import Vue from 'vue';
import ComponentLibrary from '@campusedu/component-library';
import '@campusedu/component-library/dist/component-library.css';

Vue.use( ComponentLibrary );
